/**
 * auth の API（02 5.3.1）。関数ごとに API ID を書く（03 1.5 の 2）。
 */
import type {
  AuthCodeResponse,
  AuthRefreshResponse,
  AuthVerifyResponse,
  EmailVerificationResponse,
  Me,
} from '@pcrm/shared';
import { api_client, unwrapData } from '../client';

/** API-AUTH-01 確認コードの発行・再送 */
export async function issueAuthCode(email: string): Promise<AuthCodeResponse> {
  return unwrapData(await api_client.POST('/auth/code', { body: { email } }));
}

/** API-AUTH-02 確認コードの検証・ログイン */
export async function verifyAuthCode(email: string, code: string): Promise<AuthVerifyResponse> {
  return unwrapData(await api_client.POST('/auth/verify', { body: { email, code } }));
}

/** API-AUTH-03 ログイン状態の延長 */
export async function refreshSession(): Promise<AuthRefreshResponse> {
  return unwrapData(await api_client.POST('/auth/refresh'));
}

/** API-AUTH-04 ログアウト */
export async function logout(): Promise<void> {
  await api_client.POST('/auth/logout');
}

/** API-AUTH-05 自分の情報と権限 */
export async function getMe(signal?: AbortSignal): Promise<Me> {
  return unwrapData(await api_client.GET('/auth/me', signal ? { signal } : {}));
}

/** API-AUTH-06 メール送信用のアドレス確認（Idempotency-Key 必須：02 2.8） */
export async function requestEmailVerification(
  email: string,
  idempotency_key: string,
): Promise<EmailVerificationResponse> {
  return unwrapData(
    await api_client.POST('/auth/email-verification', {
      params: { header: { 'Idempotency-Key': idempotency_key } },
      body: { email },
    }),
  );
}
